/* eslint-disable no-undef */
import {
  HttpTransportType,
  HubConnectionBuilder,
  LogLevel,
} from '@microsoft/signalr'
import { http } from './http'

let hub = null
const delay = ms => new Promise(_ => setTimeout(_, ms))

export default class CloudFlyerAPI {
  // auth, storage, mam, accounts, wasabi partner, billing

  static desktop_partner = {
    login: data => http.post(DESKTOP_WHITELABEL + '/api/Reseller/login', data),

    logout: () => {
      localStorage.clear()
    },

    request_reset_password: email =>
      http.put('/reset_password_request', { email: email }),

    resend_verification_email: data =>
      http.put('/resend_verification_email', data),

    resetPassword: data => http.put('/reset_password', data),

    changePassword: ({ old_password, new_password }) => {
      return http.put('/users/_me/change_password', {
        old_password: old_password,
        new_password: new_password,
      })
    },

    update: data => http.put('/users/_me', data),

    fetchUsers: reseller =>
      http.post(DESKTOP_WHITELABEL + '/api/User/List', reseller),

    addUser: userToAdd =>
      http.post(DESKTOP_WHITELABEL + '/api/User/Register', userToAdd),

    editUserStatus: userToEdit =>
      http.post(DESKTOP_WHITELABEL + '/api/User/change', userToEdit),
    editUserLicense: userToEdit =>
      http.post(DESKTOP_WHITELABEL + '/api/UserLicense/Detail', userToEdit),

    usersRegister: usersToAdd =>
      http.post(DESKTOP_WHITELABEL + '/api/User/Registerbulk', usersToAdd),

    addLicenseType: licenseToAdd =>
      http.post(DESKTOP_WHITELABEL + '/api/LicenseType/Add/', licenseToAdd),

    fetchLisenceType: reseller =>
      http.post(DESKTOP_WHITELABEL + '/api/LicenseType/List/', reseller),

    uploadFile: formData =>
      http.post(DESKTOP_WHITELABEL + '/api/Uploader/', formData),
  }

  static new_user_account = {
    // bypass_s3_ax_message: value =>
    //   http.put('/users/_me', {
    //     bypass_s3_ax_message: value,
    //   }),

    // register: data => http.post('/users', data),

    me: () => http.get(NEW_ANALYTICS_API + '/user/userinfo'),

    verifyUserAccount: token => http.put('/verify_user', { verification_token: token }),

    login: data => http.post('/authentication/Login', data),
    mfaRespond: data => http.post('/authentication/mfa_respond', data),
    request_temp_token: () => http.post('/authentication/request_token'),
    loginOAuth: data => http.post('/oauth', data),

    signupInfo: token => http.get(NEW_ANALYTICS_API + '/user/signupinfo?token=' + token),
    signup: user => http.post(NEW_ANALYTICS_API + '/user/signup', user),

    logout: () => {
      console.log('logout')
      localStorage.clear()
      CloudFlyerAPI.rm.stop()
      //return http.delete('/logout')
    },
    
    request_reset_password: (email, requestToken) => http.post('/authentication/forgot_password', { username: email, requestToken}),

    resend_verification_email: data => http.put('/resend_verification_email', data),

    resetPassword: (password, resetToken, requestToken)=> http.post('/authentication/reset_password', {password, resetToken, requestToken}),

    changePassword: ({ old_password, new_password }) => {
      return http.put('/users/_me/change_password', {
        old_password: old_password,
        new_password: new_password,
      })
    },

    update: data => http.put('/users/_me', data),

    fetchAll: () => http.get('/users'),

    fetchOne: id => http.get('/users/' + id),

    updateOne: (id, data) => http.put('/users/' + id, data),

    activate: id => http.put('/users/' + id + '/activate'),

    deactivate: id => http.put('/users/' + id + '/deactivate'),

    invite: users => http.post('/users/invite', users),

    fetchApi: () => http.get(ANALYTICS_API + 'apikey/ListApiKey'),

    createApi: () => http.post(ANALYTICS_API + 'apikey/CreateKey'),

    deleteApi: (apiId) => http.delete(ANALYTICS_API + 'apikey/DeleteApiKey?id='+ apiId),

    fetchSyncInfoAll: () => http.get(ANALYTICS_API + 'sync/ListSyncInfo'),

    saveSync: data => http.post(ANALYTICS_API + 'sync/AddSyncInfo', data),

    fetchSyncInfoAllWasabi: () => http.get(NEW_ANALYTICS_API + '/sync/get_jobs'),

    saveSyncWasabi: data => http.post(NEW_ANALYTICS_API + '/sync/insert', data),

    calculatePrice: data => http.post(NEW_ANALYTICS_API + '/transfer/calculate_cost', data),

    fetchObjectsList: data => http.post(NEW_ANALYTICS_API + '/cloudaccount/list_objects', data),

    triggerSyncWasabi: syncId => http.post(ANALYTICS_API + 'sync/TriggerWasabiSync?syncInfoId=' + syncId),

    deleteSyncWasabi: syncId => http.delete(NEW_ANALYTICS_API + '/sync/delete', syncId),

    activateSync: data => http.post(NEW_ANALYTICS_API + '/sync/activate', data),

    deleteSync: (syncId) => http.delete(NEW_ANALYTICS_API + '/sync/delete?id='+ syncId),

    roles: {
      fetchAll: () => http.get('/roles'),

      acls: {
        fetchAll: () => http.get('/role_access_levels/role_acls'),

        toggleEnabled: (roleAclId, enabled) => {
          return http.put('/role_access_levels/' + roleAclId, {
            role_access_level: {
              enabled,
            },
          })
        },
      },

      permissions: {
        fetchByRoleAcl: roleAclId =>
          http.get('/role_access_levels/' + roleAclId + '/role_permissions'),

        updateOne: (roleAclId, id, data) => {
          return http.put(
            '/role_access_levels/' + roleAclId + '/role_permissions/' + id,
            {
              role_permission: data,
            }
          )
        },
      },
    },

    acls: {
      fetchAll: userId => http.get('/user_access_levels/user_acls/' + userId),

      toggleEnabled: (userAclId, enabled) => {
        return http.put('/user_access_levels/' + userAclId, {
          user_access_level: {
            enabled,
          },
        })
      },
    },

    permissions: {
      fetchByUserAcl: userAclId =>
        http.get('/user_access_levels/' + userAclId + '/user_permissions/'),

      updateOne: (userAclId, id, data) => {
        return http.put(
          '/user_access_levels/' + userAclId + '/user_permissions/' + id,
          {
            user_permission: data,
          }
        )
      },
    },
    setConfirmedFlags: flags => http.put('/organizations/_me', flags),
    
  } 
  
  static user_account = {
    bypass_s3_ax_message: value =>
      http.put('/users/_me', {
        bypass_s3_ax_message: value,
      }),

    register: data => http.post('/users', data),

    me: () => http.get('/users/_me'),

    generateMFA: () => http.post(NEW_ANALYTICS_API + '/user/generate_mfa_token'),
    setMFA:  data => http.post(NEW_ANALYTICS_API + '/user/set_mfa', data),

    verifyUserAccount: token =>
      http.put('/verify_user', { verification_token: token }),

    login: data => http.post('/login', data),

    loginOAuth: data => http.post('/oauth', data),

    logout: () => {
      console.log('logout')
      localStorage.clear()
      //CloudFlyerAPI.rm.stop()
      //return http.delete('/logout')
    },

    request_reset_password: email =>
      http.put('/reset_password_request', { email: email }),

    resend_verification_email: data =>
      http.put('/resend_verification_email', data),

    resetPassword: data => http.put('/reset_password', data),

    changePassword: ({ old_password, new_password }) => {
      return http.put('/users/_me/change_password', {
        old_password: old_password,
        new_password: new_password,
      })
    },

    update: data => http.put('/users/_me', data),

    fetchAll: () => http.get('/users'),

    fetchOne: id => http.get('/users/' + id),

    updateOne: (id, data) => http.put('/users/' + id, data),

    activate: id => http.put('/users/' + id + '/activate'),

    deactivate: id => http.put('/users/' + id + '/deactivate'),

    invite: users => http.post('/users/invite', users),

    fetchApi: () => http.get(ANALYTICS_API + 'apikey/ListApiKey'),

    createApi: () => http.post(ANALYTICS_API + 'apikey/CreateKey'),

    deleteApi: (apiId) => http.delete(ANALYTICS_API + 'apikey/DeleteApiKey?id='+ apiId),

    fetchSyncInfoAll: () => http.get(ANALYTICS_API + 'sync/ListSyncInfo'),

    saveSync: data => http.post(ANALYTICS_API + 'sync/AddSyncInfo', data),

    deleteSync: (syncId) => http.delete(ANALYTICS_API + 'sync/DeleteSyncInfo?id='+ syncId),

    fetchSyncInfoAllWasabi: () => http.get(ANALYTICS_API + 'sync/ListSyncInfoWasabi'),

    saveSyncWasabi: data => http.post(ANALYTICS_API + 'sync/AddSyncInfoWasabi', data),

    triggerSyncWasabi: syncId => http.post(ANALYTICS_API + 'sync/TriggerWasabiSync?syncInfoId=' + syncId),

    deleteSyncWasabi: (syncId) => http.delete(ANALYTICS_API + 'sync/DeleteSyncInfoWasabi?id='+ syncId),    

    roles: {
      fetchAll: () => http.get('/roles'),

      acls: {
        fetchAll: () => http.get('/role_access_levels/role_acls'),

        toggleEnabled: (roleAclId, enabled) => {
          return http.put('/role_access_levels/' + roleAclId, {
            role_access_level: {
              enabled,
            },
          })
        },
      },

      permissions: {
        fetchByRoleAcl: roleAclId =>
          http.get('/role_access_levels/' + roleAclId + '/role_permissions'),

        updateOne: (roleAclId, id, data) => {
          return http.put(
            '/role_access_levels/' + roleAclId + '/role_permissions/' + id,
            {
              role_permission: data,
            }
          )
        },
      },
    },

    acls: {
      fetchAll: userId => http.get('/user_access_levels/user_acls/' + userId),

      toggleEnabled: (userAclId, enabled) => {
        return http.put('/user_access_levels/' + userAclId, {
          user_access_level: {
            enabled,
          },
        })
      },
    },

    permissions: {
      fetchByUserAcl: userAclId =>
        http.get('/user_access_levels/' + userAclId + '/user_permissions/'),

      updateOne: (userAclId, id, data) => {
        return http.put(
          '/user_access_levels/' + userAclId + '/user_permissions/' + id,
          {
            user_permission: data,
          }
        )
      },
    },
    setConfirmedFlags: flags => http.put('/organizations/_me', flags),
  }

  static new_cloud_accounts = {
    types: () => {
      return http.get('/account-types/')
    },

    get: () => {
      return http.get('/cloud_accounts/')
    },

    /* all: () => {
             return http.get('/cloud_accounts/all');
         },*/

    all: () => {
      return http.get(NEW_ANALYTICS_API + '/cloudaccount/get_all')
    },

    // clouds: () => {
    //   return http.get(ANALYTICS_API + 'CloudAccount/clouds')
    // },
    clouds: () => {
      return http.get(NEW_ANALYTICS_API + '/cloudaccount/get_all')
    },

    buckets: async (payload) => {
      return http.post(NEW_ANALYTICS_API + '/cloudaccount/list_buckets', payload)
    },

    destroy: id => {
      return http.delete(NEW_ANALYTICS_API + '/cloudaccount/delete?id=' + id)
    },

    create: data => {
      /*if (data.cloud_account.account_type_id === 'wasabi') {
              return new Promise((resolve, reject) => {
                let account = {
                  project_name: data.cloud_account.project_name,
                  account_type_id: data.cloud_account.account_type_id,
                  user_id: 127,
                  billing_bucket: 'billing_bucket',
                  db: 0,
                  total_bytes_used: 1024,
                  total_cost: 0,
                  user_count: 0,
                  bucket_count: 0,
                  per_gb: 0,
                  id: 0,
                  created_on: "2017-11-13T14:52:12Z",
                  modified_on: "0001-01-01T00:00:00Z",

                  dbs: {
                    dynamo: 0,
                    rds: 0
                  },

                  vm: {
                    running: 0,
                    stopped: 0
                  },

                  info: {
                    access_key: data.cloud_account.info.access_key_id,
                    secret_key: data.cloud_account.info.secret_access_key,
                    region: "us-east-1",
                    endpoint: 's3.wasabisys.com'
                  },

                  storages: []
                }

                localStorage.setItem('wasabi_account', JSON.stringify(account))
                resolve(account)
              })
            }*/
      console.log("herererererre");
      return http.post(NEW_ANALYTICS_API + '/cloudaccount/insert', data)
      // return http.post('/cloud_accounts/', data)
    },

    wasabi_account: () => {
      let account = JSON.parse(window.localStorage.getItem('wasabi_account'))
      if (!account) {
        return new Promise(resolve => {
          resolve()
        })
      }

      window.AWS.config.update({
        accessKeyId: account.info.access_key,
        secretAccessKey: account.info.secret_key,
        region: account.info.region,
      })

      let s3 = new window.AWS.S3({
        apiVersion: '2006-03-01',
        endpoint: account.info.endpoint,
      })

      return new Promise((resolve, reject) => {
        s3.listBuckets(function(err, data) {
          if (err) {
            return reject(err)
          }

          account.bucket_count = data.Buckets.length
          account.storages = data.Buckets.map((bucket, index) => {
            return {
              bucket_name: bucket.Name,
              CreationDate: bucket.created_on,
              region: account.info.region,
              size: 0,
              cost: 0,
              id: index,
            }
          })
          resolve(account)
        })
      })
    },

    update: function(cloud_account_id, project_name, info, billing_bucket) {
      let payload = {
        project_name: project_name, //,
        //info         : info
      }

      if (billing_bucket) {
        payload.billing_bucket = billing_bucket
      }

      return http.put('/cloud_accounts/' + cloud_account_id, {
        cloud_account: payload,
      })
    },

    summary: () => {
      return http.get(ANALYTICS_API + 'CloudAccount/Summary')
    },

    setBillingBucket: (cloud_account_id, bucketName) => {
      return http.put(
        '/cloud_accounts/' + cloud_account_id + '/update_billing_report_bucket',
        {
          billing_bucket: bucketName,
        }
      )
    },

    credentials: account_id => {
      if (account_id === undefined) {
        return http.get('/cloud_accounts/access_info')
      }
      return http.get('/cloud_accounts/' + account_id + 'access_info')
    },

    users: id => http.get('/cloud_accounts/' + id + '/users'),

    validate_bucket_name: (id, bucket_name, account_type) =>
      http.get(
        '/cloud_accounts/' +
          id +
          '/storages/exists?bucket_name=' +
          bucket_name +
          '&account_type=' +
          account_type
      ),
  }
  
  // static cloud_accounts = {
  //   types: () => {
  //     return http.get('/account-types/')
  //   },

  //   get: () => {
  //     return http.get('/cloud_accounts/')
  //   },

  //   /* all: () => {
  //            return http.get('/cloud_accounts/all');
  //        },*/

  //   all: () => {
  //     return http.get(ANALYTICS_API + 'CloudAccount/all')
  //   },

  //   clouds: () => {
  //     return http.get(ANALYTICS_API + 'CloudAccount/clouds')
  //   },

  //   buckets: id => {
  //     return http.get(ANALYTICS_API + 'CloudAccount/buckets/' + id)
  //   },

  //   destroy: id => {
  //     return http.delete('/cloud_accounts/' + id)
  //   },

  //   create: data => {
  //     /*if (data.cloud_account.account_type_id === 'wasabi') {
  //             return new Promise((resolve, reject) => {
  //               let account = {
  //                 project_name: data.cloud_account.project_name,
  //                 account_type_id: data.cloud_account.account_type_id,
  //                 user_id: 127,
  //                 billing_bucket: 'billing_bucket',
  //                 db: 0,
  //                 total_bytes_used: 1024,
  //                 total_cost: 0,
  //                 user_count: 0,
  //                 bucket_count: 0,
  //                 per_gb: 0,
  //                 id: 0,
  //                 created_on: "2017-11-13T14:52:12Z",
  //                 modified_on: "0001-01-01T00:00:00Z",

  //                 dbs: {
  //                   dynamo: 0,
  //                   rds: 0
  //                 },

  //                 vm: {
  //                   running: 0,
  //                   stopped: 0
  //                 },

  //                 info: {
  //                   access_key: data.cloud_account.info.access_key_id,
  //                   secret_key: data.cloud_account.info.secret_access_key,
  //                   region: "us-east-1",
  //                   endpoint: 's3.wasabisys.com'
  //                 },

  //                 storages: []
  //               }

  //               localStorage.setItem('wasabi_account', JSON.stringify(account))
  //               resolve(account)
  //             })
  //           }*/

  //     return http.post('/cloud_accounts/', data)
  //   },

  //   wasabi_account: () => {
  //     let account = JSON.parse(window.localStorage.getItem('wasabi_account'))
  //     if (!account) {
  //       return new Promise(resolve => {
  //         resolve()
  //       })
  //     }

  //     window.AWS.config.update({
  //       accessKeyId: account.info.access_key,
  //       secretAccessKey: account.info.secret_key,
  //       region: account.info.region,
  //     })

  //     let s3 = new window.AWS.S3({
  //       apiVersion: '2006-03-01',
  //       endpoint: account.info.endpoint,
  //     })

  //     return new Promise((resolve, reject) => {
  //       s3.listBuckets(function(err, data) {
  //         if (err) {
  //           return reject(err)
  //         }

  //         account.bucket_count = data.Buckets.length
  //         account.storages = data.Buckets.map((bucket, index) => {
  //           return {
  //             bucket_name: bucket.Name,
  //             CreationDate: bucket.created_on,
  //             region: account.info.region,
  //             size: 0,
  //             cost: 0,
  //             id: index,
  //           }
  //         })
  //         resolve(account)
  //       })
  //     })
  //   },

  //   update: function(cloud_account_id, project_name, info, billing_bucket) {
  //     let payload = {
  //       project_name: project_name, //,
  //       //info         : info
  //     }

  //     if (billing_bucket) {
  //       payload.billing_bucket = billing_bucket
  //     }

  //     return http.put('/cloud_accounts/' + cloud_account_id, {
  //       cloud_account: payload,
  //     })
  //   },

  //   summary: () => {
  //     return http.get(ANALYTICS_API + 'CloudAccount/Summary')
  //   },

  //   setBillingBucket: (cloud_account_id, bucketName) => {
  //     return http.put(
  //       '/cloud_accounts/' + cloud_account_id + '/update_billing_report_bucket',
  //       {
  //         billing_bucket: bucketName,
  //       }
  //     )
  //   },

  //   credentials: account_id => {
  //     if (account_id === undefined) {
  //       return http.get('/cloud_accounts/access_info')
  //     }
  //     return http.get('/cloud_accounts/' + account_id + 'access_info')
  //   },

  //   users: id => http.get('/cloud_accounts/' + id + '/users'),

  //   validate_bucket_name: (id, bucket_name, account_type) =>
  //     http.get(
  //       '/cloud_accounts/' +
  //         id +
  //         '/storages/exists?bucket_name=' +
  //         bucket_name +
  //         '&account_type=' +
  //         account_type
  //     ),
  // }

  static dashboard = {
    //get: (bp) => http.get(ANALYTICS_API+'dashboard/&breakPoint='+bp),
    get: () => http.get(ANALYTICS_API + 'dashboard'),
    put: data => http.put(ANALYTICS_API + 'dashboard/create', data),
    put_all: data => http.put(ANALYTICS_API + 'dashboard/createAll', data),
    delete: id => http.delete(ANALYTICS_API + 'dashboard?id=' + id),
  }

  static desktop = {
    registerStandaloneLicense: data =>
      http.post(DESKTOP + '/api/standalone/RegisterTrialLicense/', data),

    standaloneLicensePay: data =>
      http.post(DESKTOP + '/api/standalone/licensepay/', data),
  }

  static billing = {
    request_quote: (package_id, message) =>
      http.post('/packages/request_quote', {
        message: message,
        package_id: package_id,
      }),

    subscriptions: data => http.post('/billing/subscriptions/', data),

    desktopSubscriptions: data =>
      http.post('/billing/desktop/subscriptions/new_customer', data),

    getProducts: () => http.get('/billing/products'),

    packages: () => http.get('/packages'),

    getSubscription: subscriptionId =>
      http.get('/billing/subscriptions/' + subscriptionId),

    changePlan: (productHandle, subscriptionId) =>
      http.put(
        '/billing/subscriptions/' +
          subscriptionId +
          '/product_change/' +
          productHandle
      ),

    getPaymentsHistory: subscriptionId =>
      http.get('/billing/events/subscription/' + subscriptionId),

    billing_info: () => http.get('/billing/billing_info'),

    fetchPaymentProfiles: () => http.get('/billing/payment_profiles'),

    addCreditCard: ({
      billing_address,
      billing_city,
      billing_state,
      billing_zip,
      billing_country,
      billing_address_2,
      payement_type,
      full_number,
      profile_name,
      expiration_month,
      expiration_year,
      first_name,
      last_name,
    }) =>
      http.post('/billing/payment_profiles', {
        profile_create_params: {
          payment_profile: {
            billing_address,
            billing_city,
            billing_state,
            billing_zip,
            billing_country,
            billing_address_2,
            payment_type: 'credit_card',
            full_number,
            profile_name: '',
            expiration_month,
            expiration_year,
            first_name,
            last_name,
          },
        },
      }),

    updateCreditCardInfo: function(paymentId, info) {
      return http.put('/billing/payment_profiles/' + paymentId, {
        profile_update_params: { payment_profile: info },
      })
    },

    delete: id => http.delete('/billing/subscriptions/' + id),

    reactivate: id => http.put('/billing/subscriptions/' + id + '/reactivate'),

    change_card: (subscription_id, payment_profile) => {
      return http.post('/billing/payment_profiles/' + subscription_id, {
        profile_create_params: {
          payment_profile: payment_profile,
        },
      })
    },

    validate: promo_code => http.get('/billing/coupons/validate/' + promo_code),
  }

  static storages = {
    directories: (id, bucket_name, path) =>
      http.get(
        ANALYTICS_API +
          'FilesSystem/directories?id=' +
          (id || '') +
          '&bucketName=' +
          (bucket_name || '') +
          '&path=' +
          (path || '')
      ),

    getStorageList: () => http.get('/storages'),

    getFilesByPath: (id, path, limit, last_file_basename, continuationToken) => {
      console.log("getFilesByPath", id, path, limit, last_file_basename, continuationToken);

      if (!id) {
        return Promise.resolve()
      }

      if (path === null) {
        path = '/'
      }

      let url_path = '/content?'

      if (limit) {
        url_path = url_path + 'limit=' + limit
      } else {
        url_path = url_path + 'limit=' + 15
      }

      if (path) {
        url_path = url_path + '&path=' + path
      }

      if (last_file_basename) {
        url_path = url_path + '&last_file=' + last_file_basename
      }

      if (continuationToken) {
        url_path += '&continuationToken=' + continuationToken
      }

      return http.get(`/storage/${id}${url_path}`)
    },

    getToken: (id, data, type) =>
      http.post('/storage/' + id + '/content/' + type, data),

    fileTransfer: data => http.post('/transfer/', data),

    download: (id, data) =>
      http.post('/storage/' + id + '/content/download', data),

    upload: (id, data) => http.post('/storage/' + id + '/content/upload', data),

    get: id => http.get('/storage/' + id),

    create: (cloud_account_id, body) =>
      http.post('/cloud_accounts/' + cloud_account_id + '/storages', body),

    search: body => http.post('/search', body),
  }

  static slack = {
    start: () => http.get(ANALYTICS_API + 'slack/start'),

    authorize: code =>
      http.get(ANALYTICS_API + 'slack/authorize?code=' + (code ? code : '')),

    history: id => http.get(ANALYTICS_API + 'slack/history/' + id),

    channels: () => http.get(ANALYTICS_API + 'slack/channels'),

    logout: () => http.delete(ANALYTICS_API + 'slack/logout'),
  }

  static file_catalyst = {
    user: () => http.get('/file_catalyst/user'),

    settings: () => http.get('/file_catalyst/settings'),

    delete: username => http.delete('/file_catalyst/user/' + username),

    post_url: () => http.post('/file_catalyst/post_url'),

    costs: (
      service_code, // or CloudFlyer_transfer, aspera_transfer
      size, // in bytes
      direction // or download
    ) =>
      http.post('/transfers/costs', {
        service_code: service_code,
        size: size,
        direction: direction,
      }),

    transfer_agent: {
      connect: (remoteServer, remotePort, username, password) => {
        return http.get(FC_BASE_URL + 'agent/connect', {
          params: {
            remoteServer: remoteServer,
            remotePort: remotePort,
            username: username,
            password: password,
            remoteDirectory: '',
            usesSSL: false,
            createDirectoryOnConnect: true,
            lockInitialDirectory: false,
          },
        })
      },

      heartbeat: tick => {
        return http.get(FC_BASE_URL + 'agent/heartbeat', {
          params: {
            _: tick,
          },
        })
      },

      version: (version, tick) => {
        return http.get(FC_BASE_URL + 'agent/version', {
          params: {
            requester: '3.7.1+3+19',
            _: tick,
          },
        })
      },

      launch: () => {
        return new Promise((resolve, reject) => {
          try {
            let iframe = document.getElementById('launchFrame')

            if (!iframe) {
              iframe = document.createElement('iframe')
              iframe.style.display = 'none'
              iframe.id = 'launchFrame'
              iframe.src = 'about:blank'
              document.body.appendChild(iframe)
            }
            iframe.src = 'filecatalyst://localhost'
            resolve()
          } catch (e) {
            reject(e)
          }
        })
      },
    },

    transfers: {
      //http://download.filecatalyst.com/download/filesFCDirect/current/documentation/restapi/transferagent/restDocs/ui/index.html#/

      status: transfer_id => {
        if (transfer_id) {
          return http.get(FC_BASE_URL + 'agent/status/' + transfer_id)
        }

        return http.get(FC_BASE_URL + 'agent/status')
      },

      cancel: transfer_id =>
        http.get(FC_BASE_URL + 'files/transferRev1/cancel', {
          params: {
            transferID: transfer_id,
          },
        }),

      transfer_legacy: (
        source_connection_key,
        destination_connection_key,
        files,
        local_working_directory,
        remote_directory
      ) => {
        return http.post(FC_BASE_URL + 'files/transferRev1', {
          BlockSize: 5242880,
          NumberOfClients: 5,
          PostURL:
            'https://api.CloudFlyer.com/file_catalyst/post_url/?user_id=84&direction=upload&transfer_date=Thu%2C%2016%20Nov%202017%2009%3A49%3A27%20GMT&acl=private&bucket_name=CloudFlyer-test-8&anti_duplication_token=VGh1JTJDJTIwMTYlMjBOb3YlMjAyMDE3JTIwMDklM0E0OSUzQTI3JTIwR01UODR1cGxvYWRjYXRhbHlzdF90cmFuc2ZlcjYzMzA1Njc4OC40OA==',
          RemoteDirectory: remote_directory,
          SendEmailNotification: false,
          SentFilelistInEmail: false,
          TransferWithTempName: false,
          UseCongestionControl: true,
          VerifyIntegrity: false,
          VerifyMode: 0,
          DestinationConnectionKey: destination_connection_key,
          LocalWorkingDirectory: local_working_directory,
          SourceConnectionKey: source_connection_key,
          WeblinkID: '',
          fileList: files,
          jobId: '',
          transferConfiguration: {},
        })
      },

      transfer: (
        source_connection_key,
        destination_connection_key,
        files,
        local_working_directory,
        remote_directory,
        user_id,
        direction
      ) => {
        let transfer_date = encodeURIComponent(new Date().toUTCString())
        let postURL =
          API +
          '/file_catalyst/post_url/?user_id=' +
          user_id +
          '&direction=' +
          direction +
          '&transfer_date=' +
          transfer_date +
          '&bucket_name=' +
          (local_working_directory
            ? local_working_directory
            : remote_directory) +
          '&anti_duplication_token=' +
          window.btoa(
            transfer_date +
              user_id +
              direction +
              (local_working_directory
                ? local_working_directory
                : remote_directory)
          )

        return http.post(FC_BASE_URL + 'files/transferRev1', {
          DestinationConnectionKey: destination_connection_key,
          LocalWorkingDirectory: local_working_directory,
          SourceConnectionKey: source_connection_key,
          fileList: files,
          WeblinkID: null,
          jobId: null,

          transferConfiguration: {
            BlockSize: 5242880,
            NumberOfClients: 5,
            PostURL: postURL,
            RemoteDirectory: remote_directory,
            SendEmailNotification: false,
            SentFilelistInEmail: false,
            TransferWithTempName: false,
            UseCongestionControl: true,
            VerifyIntegrity: false,
            VerifyMode: 0,

            /*"IncrementalSizeCheckOnly" : true,
                        "AutoResume" : true,
                        "AutoZip" : true,
                        "CompFileFilter" : "...",
                        "CongestionControlAggression" : 12345.0,
                        "CongestionControlStrategy" : 12345.0,
                        "ConnectTimeout" : 12345.0,
                        "DeleteAfterTransfer" : true,
                        "EmailAddress" : "...",
                        "EmailBody" : "...",
                        "ExtendedReadTimeout" : 12345.0,
                        "IncrementalMode" : 12345.0,
                        "MaintainLastModified" : true,
                        "MaintainPermissions" : true,
                        "MaxRetries" : 12345.0,
                        "Md5RateLimit" : 12345.0,
                        "Mode" : 12345.0,
                        "NumBlockReaders" : 12345.0,
                        "NumBlockWriters" : 12345.0,
                        "NumFTPStreams" : 12345.0,
                        "NumPacketProcessors" : 12345.0,
                        "NumReceiveSockets" : 12345.0,
                        "NumSenderSockets" : 12345.0,
                        "NumThreads" : 12345.0,
                        "OptimizeBlockSize" : true,
                        "PacketQueueDepth" : 12345.0,
                        "PacketSize" : 12345.0,
                        "ProgressiveTimeout" : 12345.0,
                        "ProgressiveTimeoutFilter" : "...",
                        "ProgressiveTransfers" : true,
                        "ReadBufferSize" : 12345.0,
                        "ReadTimeout" : 12345.0,
                        "SendEmailNotificationPerFile" : true,
                        "StartRate" : 12345.0,
                        "TargetRate" : 12345.0,
                        "TransferEmptyDirectories" : true,
                        "TransferRate" : 12345.0,
                        "UseCompression" : true,
                        "UseIncremental" : true,
                        "UseSSL" : true,
                        "WaitRetry" : 12345.0,
                        "WriteBufferSize" : 12345.0,
                        "ZipFileSizeLimit" : 12345.0*/
          },
        })
      },

      transfer_one: (
        source_connection_key,
        destination_connection_key,
        source_file,
        destination_file,
        remote_directory
      ) => {
        return http.post(FC_BASE_URL + 'files/transferRev1', {
          DestinationConnectionKey: destination_connection_key,
          RemoteDirectory: remote_directory,
          SourceConnectionKey: source_connection_key,
          sourceFile: source_file,
          destinationFile: destination_file,
          jobId: '',
          transferConfiguration: {},
        })
      },

      upload: (files, remote_directory, connection_key, user_id) =>
        CloudFlyerAPI.file_catalyst.transfers.transfer(
          'local',
          connection_key,
          files,
          '',
          remote_directory,
          user_id,
          'upload'
        ),

      download: (files, local_directory, connection_key, user_id) =>
        CloudFlyerAPI.file_catalyst.transfers.transfer(
          connection_key,
          'local',
          files,
          local_directory,
          '',
          user_id,
          'download'
        ),

      share: (files, recipients, connection_key) => {
        return http.post(FC_BASE_URL + 'agent/weblink', {
          connectionKey: connection_key,
          fileListing: files,
          subject: 'New Files',
          userMessage: 'Files Sharing',
          toEmailAddress: recipients,
          weblinkID: 'weblinkID',
        })
      },
    },

    files: {
      local: path => {
        if (typeof path === 'undefined' || path === null) {
          path = ''
        }

        if (path.length > 0 && !path.startsWith('/')) {
          path = '/' + path
        }

        return http.get(FC_BASE_URL + 'files/local' + path, {
          params: {
            sortby: 'name',
            invert: false,
            connectionKey: 'local',
          },
        })
      },

      create_directory: (filePath, connectionKey) => {
        if (filePath.length > 0 && !filePath.startsWith('/')) {
          filePath = '/' + filePath
        }

        let path =
          (connectionKey ? 'files/remotefile' : 'files/localfile') + filePath

        return http.put(FC_BASE_URL + path)
      },

      delete_file: (filePath, connectionKey) => {
        if (filePath.length > 0 && !filePath.startsWith('/')) {
          filePath = '/' + filePath
        }

        let path =
          (connectionKey ? 'files/remotefile' : 'files/localfile') + filePath

        return http.delete(FC_BASE_URL + path)
      },

      delete_files: (files_paths, connectionKey) => {
        for (let key in files_paths) {
          if (
            files_paths[key].length > 0 &&
            !files_paths[key].startsWith('/')
          ) {
            files_paths[key] = '/' + files_paths[key]
          }
        }

        let path = connectionKey ? 'files/remotefile' : 'files/localfile'

        return http.delete(FC_BASE_URL + path, {
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ids: files_paths }),
        })
      },
    },
  }

  static notifications = {
    all: () => http.get('/notifications'),

    notifies: () => {
      let ngrok = 'http://607186be.ngrok.io/api/'
      return http.get(ANALYTICS_API + 'notifications/all') //ANALYTICS_API
    },

    read: notification_ids => {
      let ngrok = 'http://607186be.ngrok.io/api/'
      return http({
        url: ANALYTICS_API + 'notifications/read',
        method: 'PUT',
        params: { ids: notification_ids },
        paramsSerializer: ({ ids }) => {
          let param = ''
          for (let key in ids) {
            let item = ids[key]
            param += 'ids=' + item + '&'
          }
          if (param.endsWith('&')) {
            param = param.slice(0, -1)
          }
          return param
        },
      })
    },

    by_cloud_account: account_id => {
      return http.get('/cloud_accounts/' + account_id + '/notifications')
    },

    by_storage: storage_id => {
      return http.get('/storages/' + storage_id + '/notifications')
    },

    create: (cloud_account_id, bucket_name, MaxSize, MaxCost) => {
      let request = {
        notification: {
          cloud_account_id: cloud_account_id,
          service: 'S3',
        },
      }

      if (bucket_name) {
        request.notification.bucket_name = bucket_name
      }

      let promises = []

      if (MaxSize) {
        let newRequest = Object.assign({}, request)
        newRequest.notification.size_limit = MaxSize
        promises.push(http.post('/notifications/', newRequest))
      }
      if (MaxCost) {
        let newRequest = Object.assign({}, request)
        newRequest.notification.cost_limit = MaxCost
        promises.push(http.post('/notifications/', newRequest))
      }
      return Promise.all(promises)
    },

    delete: notification_id => {
      return http.delete('/notifications/' + notification_id)
    },
  }

  static transfer = {
    s3_url_signer_v4: () => http.get('/transfers/s3_url_signer_v4'),

    s3_costs: () => http.get('/transfers/s3_costs'),

    report: data => http.post('/transfers/report', data),

    update_bucket_config: (
      cors,
      s3Acceleration,
      cleanup_incomplete_multipart_lifecycle_rule,
      cloud_account_id,
      bucket_name
    ) =>
      http.put('/transfers/update_bucket_config/', {
        cors: cors,
        s3Acceleration: s3Acceleration,
        cloud_account_id: cloud_account_id,
        bucket_name: bucket_name,
        cleanup_incomplete_multipart: cleanup_incomplete_multipart_lifecycle_rule,
      }),

    summary: (start_date, end_date, service) =>
      http.get('/transfers/summary', {
        params: {
          start_date: start_date,
          end_date: end_date,
          service: service,
        },
      }),

    history: (page, limit, service) =>
      http.get('/transfers/history', {
        params: { limit: limit, page: page, service: service },
      }),

    share_by_email_files: body =>
      http.post('/transfers/share_files_by_email', body),

    share_by_slack_files: (files, channel) =>
      http.post(ANALYTICS_API + 'slack/share', { files, channel }), //ANALYTICS_API //'http://f7153c4b.ngrok.io/api/'

    download_url: (cloud_account_id, bucket_name, file_names) =>
      http({
        url: '/transfers/download_url',
        method: 'GET',
        params: {
          cloud_account_id: cloud_account_id,
          bucket_name: bucket_name,
          file_names: file_names,
        },
      }),

    delete_object: (cloud_account_id, bucket_name, file_names) =>
      http({
        url: '/transfers/delete_object',
        method: 'DELETE',
        params: {
          cloud_account_id: cloud_account_id,
          bucket_name: bucket_name,
          file_names: file_names,
        },
      }),

    create_folder: (cloud_account_id, bucket_name, folder_name) => {
      folder_name = folder_name.replace(/^\/+/g, '')
      folder_name = folder_name.replace(/([^:]\/)\/+/g, '$1')
      return http({
        url: '/transfers/create_folder',
        method: 'PUT',
        params: {
          cloud_account_id: cloud_account_id,
          bucket_name: bucket_name,
          folder_name: folder_name,
        },
      })
    },


    migration: {
      move: (payload) => http.post(NEW_ANALYTICS_API + '/transfer/transfer', payload),
      transferHistory: (transferType, pageSize, page) => http.get(NEW_ANALYTICS_API + '/transfer/get_all?type=' + transferType + '&pagesize=' + pageSize + '&page=' + page) ,
      
      // move: (files = []) => http.post(ANALYTICS_API + 'c2c/move', files),
      moveAWS: (files = []) => http.post(ANALYTICS_API + 'c2c/moveaws', files),
      moveAWS2: (files = []) => http.post(ANALYTICS_API + 'c2c/MoveAWSProd3', files),
      moveWasabi: (files = []) => http.post(ANALYTICS_API + 'c2c/moveWasabi', files),
      historyAWS: (user_Id) => {return http.get('https://c2c-status.CloudFlyer.com/api/report?userId=' + user_Id)},
      downloadFailedFile: (data = {}) => {return http.post(NEW_ANALYTICS_API + '/transfer/download_failed_files', data)},
      retryFailedFile: (data = {}) => {return http.post(NEW_ANALYTICS_API + '/transfer/retry_transfer', data)},
      cancelTransfer: (data = {}) => {return http.post(NEW_ANALYTICS_API + '/transfer/cancel_transfer', data)},
      retryAWS: (migration = []) => http.post('https://c2c.CloudFlyer.com/transfer/transfer', migration),
      historyWasabi: (user_Id) => {return http.get('https://c2c-status-wasabi.CloudFlyer.com/api/report?userId=' + user_Id)},
      downloadFailedFileWasabi: (batchTransferId) => {return http.post('https://c2c-status-wasabi.CloudFlyer.com/api/report?batchTransferId=' + batchTransferId)},
      retryWasabi: (migration = []) => http.post('https://c2c-wasabi.CloudFlyer.com/transfer/transfer', migration),

      history: (order, skip, take) => {
        let url = ANALYTICS_API + 'c2c/history?'
        if (order) url += '&order=' + order
        if (skip) url += '&skip=' + skip
        if (take) url += '&take=' + take
        return http.get(url)
      },

      usage: (from, to) =>
        http.get(`${ANALYTICS_API}c2c/usage?from=${from}&to=${to}`),

      cancel: (id = '') =>
        http.get(ANALYTICS_API + 'c2c/cancel?migrationId=' + id),
    },
  }

  static encoding = {
    presets: () => http.get(TRANSCODE_API_URL + '/transcode/presets/'),

    cancel: jobId =>
      http.delete(
        TRANSCODE_API_URL + '/jobs/' + (jobId ? jobId : '') + '/cancel'
      ),

    remove: jobId =>
      http.delete(TRANSCODE_API_URL + '/jobs/' + (jobId ? jobId : '')),

    encode: data => http.post(TRANSCODE_API_URL + '/transcode/', data),

    status: jobId =>
      http.get(TRANSCODE_API_URL + '/jobs/' + (jobId ? jobId : '') + '/status'),

    jobs: jobId => {
      if (jobId) {
        return http.get(TRANSCODE_API_URL + '/jobs/' + jobId)
      }

      return http.get(TRANSCODE_API_URL + '/jobs/')
    },
  }

  static packages = {
    request_quote: (package_id, message) =>
      http.post('/packages/request_quote', {
        message: message,
        package_id: package_id,
      }),
    request_service: (service_name, plan) =>
      http.post('/packages/request_service', {
        service_name,
        plan,
      }),
  }

  static analytics = {
    overview: (cloudId, month) => {
      return http.get(
        `${ANALYTICS_API}analytics?cloudId=${cloudId}&month=${month}`
      )
    },
    product: (cloudId, product) => {
      return http.get(
        `${ANALYTICS_API}analytics/product?cloudId=${cloudId}&product=${product}`
      )
    },
    AwsAllocationMonthlyCost: {
      GetProductCost: function(accountId, month) {
        return http.get(
          ANALYTICS_API +
            'AwsAllocationMonthlyCost/GetProductCost?awsAccountId=' +
            accountId +
            '&month=' +
            month
        )
      },

      GetAwsS3: function(accountId, month) {
        return http.get(
          ANALYTICS_API +
            'AwsAllocationMonthlyCost/GetAwsS3?awsAccountId=' +
            accountId +
            '&month=' +
            month
        )
      },

      GetAwsEC2: function(accountId, month) {
        return http.get(
          ANALYTICS_API +
            'AwsAllocationMonthlyCost/GetAwsEC2?awsAccountId=' +
            accountId +
            '&month=' +
            month
        )
      },

      GetAwsDataTransfer: function(accountId, month) {
        return http.get(
          ANALYTICS_API +
            'AwsAllocationMonthlyCost/GetAwsDataTransfer?awsAccountId=' +
            accountId +
            '&month=' +
            month
        )
      },

      GetAwsCloudWatch: function(accountId, month) {
        return http.get(
          ANALYTICS_API +
            'AwsAllocationMonthlyCost/GetAwsCloudWatch?awsAccountId=' +
            accountId +
            '&month=' +
            month
        )
      },

      GetAwsRDS: function(accountId, month) {
        return http.get(
          ANALYTICS_API +
            'AwsAllocationMonthlyCost/GetAwsRDS?awsAccountId=' +
            accountId +
            '&month=' +
            month
        )
      },

      GetAwsEFS: function(accountId, month) {
        return http.get(
          ANALYTICS_API +
            'AwsAllocationMonthlyCost/GetAwsEFS?awsAccountId=' +
            accountId +
            '&month=' +
            month
        )
      },
      GetAwsRoute53: function(accountId, month) {
        return http.get(
          ANALYTICS_API +
            'AwsAllocationMonthlyCost/GetAwsRoute53?awsAccountId=' +
            accountId +
            '&month=' +
            month
        )
      },

      GetAWSSupportBusiness: function(accountId, month) {
        return http.get(
          ANALYTICS_API +
            'AwsAllocationMonthlyCost/GetAWSSupportBusiness?awsAccountId=' +
            accountId +
            '&month=' +
            month
        )
      },

      GetAWSDirectConnect: function(accountId, month) {
        return http.get(
          ANALYTICS_API +
            'AwsAllocationMonthlyCost/GetAWSDirectConnect?awsAccountId=' +
            accountId +
            '&month=' +
            month
        )
      },
    },

    AwsDetailMonthlyCost: {
      GetRDSCost: function(accountId, month) {
        return http.get(
          ANALYTICS_API +
            'AwsDetailMonthlyCost/GetRDSCost?awsAccountId=' +
            accountId +
            '&month=' +
            month
        )
      },

      GetBucketCost: function(accountId, month) {
        return http.get(
          ANALYTICS_API +
            'AwsDetailMonthlyCost/GetBucketCost?awsAccountId=' +
            accountId +
            '&month=' +
            month
        )
      },
    },

    AwsEc2: {
      GetEC2Instance: function(accountId) {
        return http.get(
          ANALYTICS_API + 'awsEc2/getEC2instance?awsAccountId=' + accountId
        )
      },
    },

    AwsEFS: {
      GetEFSInstance: function(accountId) {
        return http.get(
          ANALYTICS_API + 'awsEFS/getEFSinstance?awsAccountId=' + accountId
        )
      },
    },
  }

  static finance = {
    yearly: (cloudid = '', year) =>
      http.get(
        `${ANALYTICS_API}budget/yearly?cloudId=${cloudid || ''}&year=${
          year ? year.toISOString() : ''
        }`
      ),

    hierarchical: (cloudid = '', year) =>
      http.get(
        `${ANALYTICS_API}budget/Hierarchical?cloudId=${cloudid || ''}&year=${
          year ? year.toISOString() : ''
        }`
      ),

    monthly: (cloudid = '', month) =>
      http.get(
        `${ANALYTICS_API}budget/monthly?cloudId=${cloudid || ''}&month=${
          month ? month.toISOString() : ''
        }`
      ),

    set_alert: body => http.put(ANALYTICS_API + 'budget/setAlert', body),

    put: (cloud = '', product = '', actual, budget, yearly, start, end) =>
      http.put(
        `${ANALYTICS_API}budget/put?cloud=${cloud ||
          ''}&product=${product}&actual=${actual || ''}&budget=${budget ||
          ''}&yearly=${yearly}&start=${start ? start.toISOString() : ''}&end=${
          end ? end.toISOString() : ''
        }`
      ),

    budget: (cloud = '', product = '') =>
      http.get(
        `${ANALYTICS_API}budget?cloud=${cloud || ''}&product=${product}`
      ),

    settings: () => http.get(ANALYTICS_API + 'budget/settings'),

    put_settings: body => http.put(ANALYTICS_API + 'budget/settings', body),

    save_product: body => http.put(ANALYTICS_API + 'budget/Product', body),

    tree: () => http.get(ANALYTICS_API + 'budget/tree'),

    chart: (cloudid = '', year) =>
      http.get(
        `${ANALYTICS_API}budget/chart?cloudId=${cloudid || ''}&year=${
          year ? year.toISOString() : ''
        }`
      ),

    alerts: () => http.get(ANALYTICS_API + 'budget/alerts'),

    delete_alert: id =>
      http.delete(`${ANALYTICS_API}budget/alert?id=${id || ''}`),

    budgets: () => http.get(ANALYTICS_API + 'budgets/request_extension'),
    audits: (from, to, entities, users, skip, take) =>
      http.get(`${ANALYTICS_API}audits/logs`, {
        params: { from, to, entities, users, skip, take },
        paramsSerializer: ({ from, to, entities, users, skip, take }) => {
          let param = `from=${from}&to=${to}&skip=${skip}&take=${take}&`
          for (let key in entities) {
            let item = entities[key]
            param += 'entities=' + item + '&'
          }
          for (let key in users) {
            let item = users[key]
            param += 'users=' + item + '&'
          }
          if (param.endsWith('&')) {
            param = param.slice(0, -1)
          }
          return param
        },
      }),
    filters: () => http.get(`${ANALYTICS_API}audits/filters`),
  }

  static rm = {
    open: () => {
      if ((!hub || (hub && hub.stopped)) && localStorage.Authorization) {
        hub = new HubConnectionBuilder()
          .configureLogging(LogLevel.Error)
          .withUrl(
            `${NEW_ANALYTICS_API}/rm?access_token=Bearer ${localStorage.Authorization}`,
            { accessTokenFactory: () => localStorage.Authorization }
          ) //transport:HttpTransportType.WebSockets, skipNegotiation:true
          .withAutomaticReconnect([0, 0, 10000])
          .build()
        hub
          .start()
          .then(() => delete hub.stopped)
          .catch(e => {
            hub = null
            console.error(e)
          })
        hub.onclose(async () => {
          if (!hub) return
          hub.stopped = true
          if (hub.stopping) {
            console.log('RTM Stopped')
          } else {
            hub = null
            console.error('RTM Failed')
            /*while (!hub && localStorage.Authorization) {
                          console.log('retrying rm ...')
                          CloudFlyerAPI.rm.open()
                          await new Promise(resolve => setTimeout(resolve, 1000))
                        }*/
          }
        })
      }
      return hub
    },

    on: func => {
      if (CloudFlyerAPI.rm.open()) hub.on('rm', func)
    },

    stop: () => {
      if (CloudFlyerAPI.rm.open()) {
        hub.stopping = true
        hub.stop()
        hub = null
        console.log('RTM stopped')
      }
    },
  }

  static quota = {
    request_extension: message =>
      http.post('/quota/request_extension', { message }),
  }

  static metadata = {
    save: metadata => http.post(ANALYTICS_API + 'metadata/Add', metadata),

    delete: (cloud, storage, path, name) => {
      let params = JSON.stringify({ cloud, storage, path, name })
      return http.delete(ANALYTICS_API + 'metadata/delete', {
        params,
        headers: { 'Content-Type': 'application/json' },
        data: params,
      })
    },

    all: (cloud, storage, path, format, file_id) =>
      http.get(
        `${ANALYTICS_API}metadata/all?cloud=${cloud}&storage=${storage}&path=${path}&format=${format}&fileId=${file_id}`
      ),
  }

  static hybrik = {
    fetchProfiles: () => http.get('/hybrik/profiles'),
    createProfile: formData => http.post('/hybrik/profiles', formData),
    deleteProfile: id => http.delete('/hybrik/profiles/' + id),
    fetchJobs: status => http.get('/hybrik/jobs?status=' + status),
    createJob: body => http.post('/hybrik/jobs', body),
  }

  static wasabi = {
    create: data => http.post('/wasabi_sub_accounts', data),

    add: data => http.post('/cloud_accounts/', data),
  }

  static sharing = {
    info: id => http.get('/sharing/' + (id || '')),

    verify_password: data => http.post('/sharing/verify_password', data),
  }

  static ftx = {
    launch: () =>
      new Promise(async (resolve, reject) => {
        try {
          let iframe = document.getElementById('launchFrame')

          if (!iframe) {
            iframe = document.createElement('iframe')
            iframe.style.display = 'none'
            iframe.id = 'launchFrame'
            iframe.src = 'about:blank'
            document.body.appendChild(iframe)
          }
          iframe.src = 'ftx://localhost'
          await delay(2000)
          resolve()
        } catch (e) {
          reject(e)
        }
      }),

    connect: () =>
      http.get(
        `${FTX_LOCAL}ftx/Connect?ftxServerAddress=${FTX_HOST}&ftxServicePort=${FTX_PORT}`
      ),

    files: (path, skip, limit) =>
      http.get(
        FTX_LOCAL +
          'ftx/GetContents?limit=' +
          (limit || '100') +
          '&skip=' +
          (skip || '0') +
          '&path=' +
          (path || '')
      ),

    GetLocalDrives: () => http.get(`${FTX_LOCAL}ftx/GetLocalDrives`),

    GetStatus: id => http.get(`${FTX_LOCAL}ftx/GetStatus?id=${id}`),

    move: migration => http.post(`${FTX_LOCAL}ftx/Send`, migration),
  }

  static mam = {
    search: body => http.post('/search', body),

    createProxyFiles: body => http.post('/search/proxy_files_locations/', body),

    getProxyFiles: () => http.get('/search/proxy_files_locations/'),

    findProxyFiles: body => http.post('/search/proxy_files', body),
  }

  static backblaze = {
    authorize: (cloud, cancelToken) =>
      http.get(`${ANALYTICS_API}CloudAccount/backblaze/authorize/${cloud}`, {
        cancelToken: cancelToken,
      }),

    initiate_upload: (cloud, bucketId, fileName, concurrency, cancelToken) =>
      http.get(
        `${ANALYTICS_API}CloudAccount/initiateUpload/${bucketId}?filename=${fileName}&concurrency=${concurrency}`,
        { cancelToken: cancelToken }
      ),

    part_url: (count, url, authorization, file_id, cancelToken) =>
      http.post(
        `${ANALYTICS_API}CloudAccount/PartUrl?count=${count}`,
        {
          url,
          authorization,
          file_id,
        },
        { cancelToken: cancelToken }
      ),

    upload_url: (cloud, bucketId, cancelToken) =>
      http.get(`${ANALYTICS_API}CloudAccount/uploadUrl/${bucketId}`, {
        cancelToken: cancelToken,
      }),

    upload_part: ({
      url,
      authorization,
      part,
      sha1,
      stream,
      progress,
      cancelToken,
    }) => {
      return http.post(`${url}`, stream, {
        headers: {
          Authorization: authorization,
          'X-Bz-Part-Number': part,
          'X-Bz-Content-Sha1': sha1,
        },
        cancelToken,
        onUploadProgress: progressEvent => progress(progressEvent),
      })
    },

    upload: ({ url, token, file, file_name, sha1, progress, cancelToken }) => {
      return http.post(`${url}`, file, {
        headers: {
          Authorization: token,
          'X-Bz-File-Name': encodeURIComponent(file_name),
          'X-Bz-Content-Sha1': sha1,
          'Content-Type': file.type,
        },
        cancelToken,
        onUploadProgress: progressEvent => progress(progressEvent),
      })
    },

    finish_upload: (cloud_id, file_id, sha1s, cancelToken) =>
      http.post(
        `${ANALYTICS_API}CloudAccount/finishUpload/${cloud_id}`,
        {
          file_id,
          sha1s,
        },
        { cancelToken: cancelToken }
      ),

    parts: (cloud, file_id, cancelToken) =>
      http.get(
        `${ANALYTICS_API}CloudAccount/parts?cloud=${cloud}&fileId=${file_id}`,
        { cancelToken: cancelToken }
      ),

    verify_part: (part, size, sha1, cloud, file_id, cancelToken) =>
      http.get(
        `${ANALYTICS_API}CloudAccount/verifyPart/${cloud}?fileId=${file_id}&part=${part}&size=${size}&sha1=${sha1}`,
        { cancelToken: cancelToken }
      ),

    cancel: (cloud, file_id) =>
      http.delete(`${ANALYTICS_API}CloudAccount/cancel/${cloud}/${file_id}`),

    apply_cors: (cloud, bucket_id, cancelToken) =>
      http.get(`${ANALYTICS_API}CloudAccount/applyCors/${bucket_id}`, {
        cancelToken: cancelToken,
      }),
  }
}
